import { render, staticRenderFns } from "./switch-button.vue?vue&type=template&id=5cf556f6&scoped=true&"
import script from "./switch-button.ts?vue&type=script&lang=ts&"
export * from "./switch-button.ts?vue&type=script&lang=ts&"
import style0 from "./switch-button.scss?vue&type=style&index=0&id=5cf556f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf556f6",
  null
  
)

export default component.exports